export const StringFilterOptions = {
    INCLUDES: {
        value: 'obsahuje',
        key: 'ilike',
    },
    EQUALS: {
        value: 'rovná se',
        key: 'eq',
    },
    STARTS_WITH: {
        value: 'začíná',
        key: 'startswith',
    },
} as const

export const BoolFilterOptions = {
    EQUALS: {
        value: 'rovná se',
        key: 'eq',
    },
    NOT_EQUALS: {
        value: 'nerovná se',
        key: 'neq',
    },
} as const

export const NumberFilterOptions = {
    BIGGER: {
        value: 'větší než',
        key: 'gt',
    },
    SMALLER: {
        value: 'menší než',
        key: 'lt',
    },
    EQUALS: {
        value: 'rovná se',
        key: 'eq',
    },
    IN: {
        value: 'v',
        key: 'in',
    }
} as const

export const DateFilterOptions = {
    ...NumberFilterOptions,
    BETWEEN: {
        value: 'mezi',
        key: 'between',
    },
} as const

export type FilterOperators =
    | (typeof StringFilterOptions)[keyof typeof StringFilterOptions]['key']
    | (typeof BoolFilterOptions)[keyof typeof BoolFilterOptions]['key']
    | (typeof NumberFilterOptions)[keyof typeof NumberFilterOptions]['key']
    | (typeof DateFilterOptions)[keyof typeof DateFilterOptions]['key']
